export default __webpack_public_path__ + "static/media/m_engineering_card20_1.4922f742.png";